/* eslint-disable no-nested-ternary */
import React, { useState, useEffect } from 'react';
import {
    TabContent,
    TabPane,
    Nav,
    NavItem,
    NavLink,
    Row,
    Col,
    Input,
} from 'reactstrap';
import classnames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import { SpinnerConstructor } from '../../../../shared/components';
import { useAppContext } from '../../../../shared/contexts/AppContextProvider';

import DOMPurify from 'dompurify';

const InformacoesGerais = React.lazy(() => import('./InformacoesGerais'));
const GuiaAtendimento = React.lazy(() => import('./GuiaAtendimento'));
const GuiaEvento = React.lazy(() => import('./GuiaEvento'));

const GuiasConteudoPersonalizado = ({ cod_biblioteca = null, tipo_catalogo = null }) => {
    const { t } = useTranslation();
    // States
    const [activeTab, setActiveTab] = useState(0);
    const [collapse, setCollapse] = useState({ id: 5, status: false });
    const [tabs, setTabs] = useState(null);
    const [loading, setLoading] = useState(false);
    const { serviceData } = useAppContext();

    const normalizeLibraryCode = value => {
        if (value === null || value === undefined || value === '') {
            return null;
        }
        return Number(value);
    };

    const selectedLibraryCode = normalizeLibraryCode(cod_biblioteca);

    const filterByLibrary = tab => {
        if (selectedLibraryCode === null) {
            return true;
        }

        const tabLibraryCode = normalizeLibraryCode(tab.cod_biblioteca);

        // Exibe conteúdo específico da biblioteca selecionada e também conteúdo global.
        return tabLibraryCode === null || tabLibraryCode === 0 || tabLibraryCode === selectedLibraryCode;
    };

    const filterContent = tab => {
        return (
            ((tab.tipo === 'HTML' || tab.tipo === 'TEXT') &&
                tab.conteudo &&
                tab.conteudo.trim().length > 0) ||
            (tab.tipo !== 'HTML' && tab.tipo !== 'TEXT')
        );
    };

    const availableTabs = tabs ? tabs.filter(tab => filterByLibrary(tab) && filterContent(tab)) : [];

    useEffect(() => {
        let isMounted = true;
        setLoading(true);
        /**
         * Dados ja carregados no contexto
         */
        if(serviceData !== null){
            if(isMounted){
                setTabs(serviceData);
                setLoading(false);
            }
        }

        return () => {
            isMounted = false;
        };
    }, [serviceData, tipo_catalogo]);

    useEffect(() => {
        if (activeTab > availableTabs.length - 1) {
            setActiveTab(0);
        }
    }, [availableTabs.length, activeTab]);

    const toggle = id => {
        if (activeTab !== id) {
            setActiveTab(id);
            setCollapse({ id, status: true });
        } else {
            setCollapse({ id, status: !collapse.status });
        }
    };

    if (loading) {
        return (
            <Row>
                <Col md="12" xs="12" className="text-center p-5">
                    <SpinnerConstructor
                        visible
                        height={70}
                        width={70}
                        className="cortxt"
                    />
                </Col>
            </Row>
        );
    }

    return (
        <div className="info__tabs animated fadeIn b-w1 b-solid-bottom b-tema30 ">
            {/* Tabs por link - visível para telas grandes: */}
            {tabs ? (
                availableTabs.length ? (
                    <div>
                        <Nav tabs className="info__tabs__tabs  preto">
                            {availableTabs.map((tab, id) => {
                                let ativo = Number(activeTab) === Number(id);
                                return (
                                    <div className="d-none d-md-block" key={`tabLink-${id}`}>
                                        <NavItem
                                            className={classnames('', {
                                                'b-w1': ativo,
                                                'b-solid-bottom': ativo,
                                                'b-branco': ativo,
                                            })}
                                        >
                                            <NavLink
                                                className={classnames('click', {
                                                    active: ativo,
                                                    cortxt: ativo,
                                                })}
                                                onClick={() => toggle(id)}
                                            >
                                                {tab.icone ? (
                                                    <FontAwesomeIcon
                                                        icon={['fa', tab.icone]}
                                                        className={classnames(
                                                            'r5 b-tema20 s15 s30m',
                                                            {
                                                                cortxt70: ativo,
                                                                preto50: !ativo,
                                                            },
                                                        )}
                                                        size="xs"
                                                    />
                                                ) : null}
                                                <span
                                                    className={classnames(
                                                        ' pad5 s14 d-none d-lg-block float-right',
                                                        {
                                                            cortxt: ativo,
                                                            f900: ativo,
                                                            f500: !ativo,
                                                            preto70: !ativo,
                                                        },
                                                    )}
                                                >
                                                {tab.titulo}
                                            </span>
                                            </NavLink>
                                        </NavItem>
                                    </div>
                                );
                            })}


                            <Input className="d-md-none mb-2" type="select"
                                   value={Number(activeTab)}
                                   onChange={e => toggle(parseInt(e.target.value))}>
                                {availableTabs.map((tab, id) => {
                                    return (
                                        <option  value={id} key={`tab-option-${id}`}>{tab.titulo}</option>
                                    );
                                })}
                            </Input>

                        </Nav>
                        <TabContent
                            activeTab={activeTab}
                            className="info__tabs__content b-w1 b-solid-top b-tema30 "
                        >
                            {availableTabs.map((tab, id) => (
                                <TabPane key={`tabContent-${id}`} tabId={id}>
                                    <Row>
                                        <Col sm="12">
                                            <Row className="card__header">
                                                {tab.icone ? (
                                                    <Col
                                                        xs="3"
                                                        sm="3"
                                                        md="2"
                                                        lg="1"
                                                        className="d-none d-md-block"
                                                    >
                                                        <FontAwesomeIcon
                                                            icon={[
                                                                'fa',
                                                                tab.icone,
                                                            ]}
                                                            className={
                                                                'icone-header cortxt'
                                                            }
                                                        />
                                                    </Col>
                                                ) : null}
                                                <Col
                                                    xs="12"
                                                    sm="9"
                                                    md="10"
                                                    lg="11"
                                                    className="card__header__title cortxt s30 f300 b-w1 b-tema70 pad5 negrito s18 mb-md-3"
                                                >
                                                    {tab.titulo}
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col
                                                    xs="12"
                                                    md={{ size: 12, offset: 0 }}
                                                >
                                                    {(() => {
                                                        switch (tab.tipo) {
                                                            case 'INFORMACOES_GERAIS':
                                                                return (
                                                                    <InformacoesGerais
                                                                        t={t}
                                                                    />
                                                                );
                                                            case 'ATENDIMENTO':
                                                                return (
                                                                    <GuiaAtendimento />
                                                                );
                                                            case 'EVENTOS':
                                                                return (
                                                                    <GuiaEvento />
                                                                );
                                                            case 'HTML':
                                                                return (
                                                                    <GuiaConteudoHTML
                                                                        conteudo={
                                                                            tab.conteudo
                                                                        }
                                                                    />
                                                                );
                                                            case 'TEXT':
                                                                return (
                                                                    <GuiaConteudoTextual
                                                                        conteudo={
                                                                            tab.conteudo
                                                                        }
                                                                    />
                                                                );
                                                            default:
                                                                return t(
                                                                    'NaoDisponivel',
                                                                );
                                                        }
                                                    })()}
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </TabPane>
                            ))}
                        </TabContent>
                    </div>
                ) : (
                    <div />
                )
            ) : loading && (
                <Row>
                    <Col md="12" xs="12" className="text-center p-5">
                        <SpinnerConstructor
                            visible
                            height={70}
                            width={70}
                            className="cortxt"
                        />
                    </Col>
                </Row>
            )}
        </div>
    );
};

const GuiaConteudoTextual = props => {
    return (
        <div className="pl-4 pb-3">
            <span
                style={{ whiteSpace: 'pre-line' }}
                className="preto70 s15 f400"
            >
                {props.conteudo}
            </span>
        </div>
    );
};

const GuiaConteudoHTML = props => {
    const sanitizedContent = DOMPurify.sanitize(props.conteudo, {
        ADD_ATTR: ['target'],
    });
    return (
        <div
            className="pl-4 pb-3 preto70 f400"
            dangerouslySetInnerHTML={{ __html: sanitizedContent }}
        />
    );
};

export default GuiasConteudoPersonalizado;
